import { useEffect, useRef } from 'react';
import { Content, JSONContent, JSONData, JSONEditor as SvelteJSONEditor } from 'svelte-jsoneditor/dist/jsoneditor.js';

const JSONEditor: React.FC<{
  value: string;
  onChange: (newContent: string | JSONData) => void;
}> = props => {
  const { value, onChange } = props;
  const refContainer = useRef<HTMLDivElement>(null);
  const refEditor = useRef<SvelteJSONEditor | null>(null);
  const refContent = useRef<JSONContent>({ text: undefined, json: value });

  useEffect(() => {
    if (refContainer.current) {
      // create editor
      refEditor.current = new SvelteJSONEditor({
        target: refContainer.current,
        props: {
          content: refContent.current
        }
      });
    }

    return () => {
      // destroy editor
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, []);

  // update props
  useEffect(() => {
    if (refEditor.current) {
      refEditor.current.updateProps({
        ...props,
        onChange: (newContent: Content) => {
          if ('text' in newContent && newContent.text) {
            try {
              onChange(JSON.parse(newContent.text));
            } catch (e) {
              console.error('Invalid JSON, value not saved');
            }
          } else if ('json' in newContent && newContent.json) {
            onChange(newContent.json);
          }
        }
      });
    }
  }, [props, onChange]);

  return <div className="svelte-jsoneditor-react" ref={refContainer}></div>;
};

export default JSONEditor;
